var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3498 16.2519L17.3186 14.0948C17.1037 14.0032 16.8647 13.9839 16.6379 14.0399C16.411 14.0959 16.2085 14.2242 16.0608 14.4053L13.8271 17.1336C10.3291 15.4834 7.51464 12.6667 5.86683 9.16724L8.58978 6.93815C8.77122 6.79072 8.89967 6.58816 8.95568 6.36117C9.01169 6.13417 8.99221 5.89511 8.90019 5.68018L6.74344 0.648277C6.64181 0.41726 6.46287 0.228886 6.23738 0.115563C6.0119 0.00223861 5.75398 -0.0289503 5.50799 0.0273613L0.835635 1.10279C0.598073 1.15756 0.386099 1.29128 0.234326 1.48209C0.0825523 1.67291 -5.24778e-05 1.90955 1.4798e-07 2.15338C-0.000326035 4.89109 0.538589 7.60204 1.58597 10.1314C2.63335 12.6608 4.16867 14.959 6.10425 16.8949C8.03983 18.8307 10.3377 20.3663 12.8668 21.4138C15.3958 22.4613 18.1064 23.0003 20.8437 23C21.0877 23.0003 21.3246 22.9178 21.5156 22.766C21.7067 22.6142 21.8406 22.402 21.8954 22.1642L22.9731 17.4912C23.0292 17.2433 22.997 16.9836 22.882 16.7569C22.7671 16.5302 22.5767 16.3507 22.3436 16.2494L22.3498 16.2519Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6c0cd9e6e65c937115c9cf05dc552ce7.svg";
export { ForwardRef as ReactComponent };